import { SPACING, SPACING_PX } from '../../core/constants/tokens-spacing.js';
/**
 * Below are Legacy names and should be avoided in use,
 * as they don't follow any particular naming or casing convention
 */

/**
* @deprecated Use SPACING in its place
*/

var spacing = SPACING;
/**
 * @deprecated Use SPACING_PX in its place
 */

var spacingPx = SPACING_PX;
export { spacing, spacingPx };